module.exports = require("puppeteer-extra-plugin-stealth");